// https://vuex.vuejs.org/en/actions.html
import refresh from "../plugins/axios_refresh";
import axios from "../plugins/axios";
import router from "../router/index";
var jwt = require("jsonwebtoken");
import axiosCancel from "axios-cancel";

export default {
  change: ({ state }) => {
    state.app.form.hasChange = true;
  },
  checkStatistics: ({ state, rootState, dispatch }) => {
    axios
      .post("/api/statistics", {
        oc: rootState.app.settings.count_objects
      })
      .then(response => {
        if (rootState.app.settings.count_objects != response.data.oc) {
          dispatch("getObjects");
        }
        rootState.app.settings.count_objects = response.data.oc;
      });
  },

  resetUser: context => {
    //   "resetting the state, reaching out to the api to get the previous state"
    // );
  },
  // check if the user is authenticated, if not route the user to the login page
  checkAuth: ({ state }) => {
    if (state.auth.authenticated === false) {
      localStorage.removeItem("token");
      router.push("/login");
    }
  },

  // object actions
  newObject: ({ state }) => {
    state.temp_address = {};
    state.createObject.show = true;
  },
  getObjects: ({ state }) => {
    state.app.objects.loading = true;

    axios
      .get("/api/objects", {})
      .then(response => {
        state.objects = response.data;
        state.app.objects.loading = false;
      })
      .catch(e => {});
  },
  getObject: ({ state, dispatch }, payload) => {
    axios.get("api/object/" + payload.reference).then(response => {
      dispatch("getTemplates", {
        reference: response.data.category.reference
      });
      state.object = response.data;
      state.details = response.data.details;
    });
  },
  deleteObject: ({ state }, payload) => {
    axios.delete("api/object/" + payload.reference).then(response => {
      state.objects = response.data;
    });
  },
  createKadasterObject: ({ state, dispatch }, payload) => {
    axios
      .post("api/objects", {
        reference: payload.reference
      })
      .then(response => {
        dispatch("setKadasterDetails", {
          id: payload.id
        });
        state.createObject.show = false;
      });
  },
  setKadasterDetails: ({ state, dispatch }, payload) => {
    fetch(
      "https://geodata.nationaalgeoregister.nl/locatieserver/v3/lookup?id=" +
        payload.id
    )
      .then(res => res.json())
      .then(res => {
        state.temp_address = {};
        state.temp_address = res.response.docs[0];

        if (payload.new == false) {
          dispatch("processKadasterDetails", {
            vastgoed: payload.vastgoed, 
            organisation : payload.organisation
          });
        }

        dispatch("change");
      });
  },

  // to be replaced by the address.js module
  processKadasterDetails: ({ state }, payload) => {

    if (payload.organisation == false) { 

      if (
        state.temp_address.straatnaam !== undefined &&
        state.temp_address.huis_nlt !== undefined
      ) {
        state.object.details.address =
          state.temp_address.straatnaam + " " + state.temp_address.huis_nlt;
      }      

      if (state.temp_address.postcode !== undefined) {
        state.object.details.postal_code = state.temp_address.postcode;
      }
      if (state.temp_address.woonplaatsnaam !== undefined) {
        state.object.details.city = state.temp_address.woonplaatsnaam;
      }
      if (state.temp_address.id !== undefined) {
        state.object.details.adr_id = state.temp_address.id;
      }

      if (payload.vastgoed == true) {
        state.object.details.name = state.object.details.address;
        state.object.details.woonplaatscode = state.temp_address.woonplaatscode;
        state.object.details.county = state.temp_address.provincienaam;
        state.object.details.provinciecode = state.temp_address.provinciecode;
        if (state.temp_address.gekoppeld_perceel !== undefined) {
          state.object.details.perceel = state.temp_address.gekoppeld_perceel[0];
        }
        state.object.details.country = "Nederland";
        state.object.details.wijkcode = state.temp_address.wijkcode;
        state.object.details.buurtcode = state.temp_address.buurtcode;
        state.object.details.wijknaam = state.temp_address.wijknaam;
        state.object.details.buurtnaam = state.temp_address.buurtnaam;
      }
    } else if (payload.organisation == true) {

      if (
        state.temp_address.straatnaam !== undefined &&
        state.temp_address.huis_nlt !== undefined
      ) {
        state.user.organisation.details.address =
          state.temp_address.straatnaam + " " + state.temp_address.huis_nlt;
      }      

      if (state.temp_address.postcode !== undefined) {
        state.user.organisation.details.postal_code = state.temp_address.postcode;
      }
      if (state.temp_address.woonplaatsnaam !== undefined) {
        state.user.organisation.details.city = state.temp_address.woonplaatsnaam;      
      }

    }
  },
  createMultipleObjects: ({state}, payload) => {
      axios.post("api/objects", {
        reference: payload.reference,
        details: payload.details
      }).then(response => {
        state.objects = response.data;
        state.createObject.show = false;
      });
  },

  createObject: ({ state, dispatch }, payload) => {
    axios
      .post("api/objects", {
        reference: payload.reference
      })
      .then(response => {
        state.object = response.data;
        state.object.details = payload.details;
        state.contracts = [];

        dispatch("updateObject").then((response) => {
          router.push('/object')
        });

        state.createObject.show = false;

      });
  },
  createObjectInContract: ({ state, dispatch }, payload) => {
    axios
      .post("api/objects", {
        reference: payload.reference
      })
      .then(response => {
        var object = response.data;
        object.details = payload.details;
        axios.put("api/object/" + object.reference, object).then(response => {
          state.app.form.hasChange = false;
          axios.get("/api/objects", {}).then(response => {
            state.objects = response.data;
            state.contract["party_" + (payload.index + 1)] = object.reference;
            state.createObject.show = false;
          });
        });
      });
  },

  clearObject: ({ state }) => {
    state.object = {};
  },
  resetObject: ({ state, dispatch }) => {
    dispatch("getObject", {
      reference: state.object.reference
    });
    state.app.form.hasChange = false;
  },
  updateObject: ({ state, dispatch }) => {
    axios
      .put("api/object/" + state.object.reference, state.object)
      .then(response => {
        state.app.form.hasChange = false;
        state.app.details.show = false;
        // dispatch("toObject", {
        //   reference: response.data.reference
        // });
        dispatch("getObjects");
      });
  },
  getTypes: ({ state }) => {
    axios.get("api/types").then(response => {
      state.types = response.data;
    });
  },

  getType: ({ state }, payload) => {
    axios.get("api/type/" + payload.reference).then(response => {
      state.type = response.data;
    });
  },

  updateType: ({ state, dispatch }) => {
    axios.put("api/type/" + state.type.reference, state.type).then(response => {
      state.type = response.data;
      dispatch("getTypes");
    });
  },
  createType: ({ state, dispatch }, payload) => {
    axios.post("api/types", payload).then(response => {
      state.type = response.data;
      dispatch("getTypes");
    });
  },
  deleteType: ({ state }) => {
    axios
      .delete("api/type/" + state.type.reference, state.type)
      .then(response => {
        state.settings.deleteObject = false;
        state.type = [];
        state.types = response.data;
      });
  },

  // contract actions

  getContracts: ({ state }, payload) => {
    state.app.contracts.loading = true;
    axios.get("api/contracts/" + payload.parent).then(response => {
      state.contracts = response.data;
      state.app.contracts.loading = false;
    });
  },

  getAllContracts: ({ state }) => {
    state.contracts = [];
    state.app.contracts.loading = true;
    axios.get("api/contracts/").then(response => {
      state.contracts = response.data;
      state.app.contracts.loading = false;
    });
  },

  createContract: ({ state, dispatch }, payload) => {
    axios
      .post("api/contracts/" + payload.parent, {
        template: payload.template
      })
      .then(response => {
        state.contract = response.data;

        router.push("/contract");

        dispatch("getContracts", {
          parent: state.object.reference
        });
      });
  },

  createUndefinedContract: ({state, dispatch}, payload) => {
      axios
      .post("api/contracts/" + payload.parent, {
        template: payload.template
      })
      .then(response => {
        state.contract = response.data;

        router.push("/contract");

        dispatch("getAllContracts");
      });
  },

  getContract: ({ state, dispatch }, payload) => {
    axios.get("api/contract/" + payload.reference).then(response => {
      dispatch("getObject", {
        reference: response.data.parent
      });
      state.contract = response.data;
    });
  },

  initializeMerkato: ({ state, dispatch }) => {
    state.app.merkato.load = true;
    axios
      .post("api/initialize/" + state.contract.reference, state.contract)
      .then(response => {
        if (state.app.merkato.load) {         
          state.contract = response.data;
          
          dispatch("auth/getAuthentication", null, {root:true}).then(()=> {
            state.app.merkato.load = false; 
            state.app.merkato.show = true;
          }).catch( ()=> {
            state.app.merkato.load = false; 
            state.app.merkato.show = false;
            state.app.merkato.initializeError = true;
          })

        } else {
          console.log('not showing merkato screen after initialization')
          state.app.merkato.show = false;
        }
      }).catch( () => {
        state.app.merkato.load = false; 
        state.app.merkato.show = false;
        state.app.merkato.initializeError = true;
      });
  },


  updateContract: ({ state }) => {
    axios
      .put("api/contract/" + state.contract.reference, state.contract)
      .then(response => {
        state.app.contract.hasChange = false;
        state.contract = response.data;
      });
  },

  deleteContract: ({ state }, payload) => {
    if (router.currentRoute.path == "/contracten") {
      state.app.contracts.loading = true;
      axios
        .put("api/contracts/", {
          reference: payload.reference,
          archive: true
        })
        .then(response => {
          state.contracts = response.data;
          state.app.contracts.loading = false;
        });
    } else {
      axios.delete("api/contract/" + payload.reference).then(response => {
        state.contracts = response.data;
      });
    }
  },

  // log

  getContractLog: ({ state }) => {
    axios.get("api/log/" + state.contract.reference).then(response => {
      state.log = response.data;
    });
  },

  // document

  getDocument: ({ state }) => {
    axios.get("api/retreive/" + state.contract.reference).then(response => {
      var base64ToString =
        process.env.VUE_ENV === "server"
          ? function(base64) {
              return Buffer.from(base64, "base64").toString();
            }
          : window.atob;

      state.pdfStore.available = true;
      state.pdfStore.download =
        "data:application/octet-stream;base64," + response.data;

      var binaryVersionOfThePdf = base64ToString(response.data);
      state.pdfStore.file = { data: binaryVersionOfThePdf };
    });
  },

  // contract handlers

  resetContract: ({ state, dispatch }) => {
    dispatch("getContract", {
      reference: state.contract.reference
    });
    state.app.contract.hasChange = false;
  },

  resetContract: ({ state, dispatch }) => {
    dispatch("getContract", {
      reference: state.contract.reference
    });
    state.app.contract.hasChange = false;
  },

  // templates

  getTemplates: ({ state }, payload) => {
    axios
      .post("api/templates", {
        object_type: payload.reference
      })
      .then(response => {
        state.templates = response.data;
      });
  },

  getAllTemplates : ({state}) => {
    axios.get("api/templates").then(response => {
      state.templates = response.data;
    })
  },

  settingsGetTemplates: ({ state }, payload) => {
    axios.get("api/templates").then(response => {
      state.settings.templates = response.data;
    });
  },

  settingsGetTemplate: ({ state }, payload) => {
    axios
      .post("api/settings/template", {
        reference: payload.reference
      })
      .then(response => {
        state.settings.template = response.data;
      });
  },

  updateTemplate: ({ state, dispatch }) => {
    axios
      .patch("api/settings/template", state.settings.template)
      .then(response => {
        state.settings.template = response.data;
        dispatch("settingsGetTemplates");
      });
  },

  createTemplate: ({ state, dispatch }, payload) => {
    axios.put("api/settings/template", payload).then(response => {
      state.settings.template = response.data;
      dispatch("settingsGetTemplates");
      state.settings.newTemplate.show = false;
    });
  },

  // form functionallity

  getForms: ({ state }) => {
    axios.get("api/forms/").then(response => {
      state.forms = response.data;
    });
  },
  getForm: ({ state }, payload) => {
    axios.get("api/form/" + payload.reference).then(response => {
      state.form.content = response.data;
    });
  },
  deleteForm: ({ state }, payload) => {
    axios.delete("api/form/" + payload.reference).then(response => {
      state.forms = response.data;
    });
  },

  createForm: ({ state }, payload) => {
    axios
      .post("api/forms/", {
        template: state.form.reference,
        objects : payload.objects
      })
      .then(response => {
        state.forms = response.data;
        state.form.reference = "";
        state.form.create = false;
      });
  },
  getFormLog: ({ state }, payload) => {
    axios.get("api/form/log/" + payload.reference).then(response => {
      state.log = response.data;
    });
  },

  // form template functionallity
  getFormTemplates: ({ state, dispatch }) => {
    axios.get("api/forms/templates").then(response => {
      state.form.templates = response.data;
    });
  },
  getFormTemplate: ({ state, dispatch }, payload) => {
    axios.get("api/forms/template/" + payload.reference).then(response => {
      dispatch("getFormObject", { reference: response.data.object });
      state.form.template = response.data;
    });
  },

  getFormObject: ({ state }, payload) => {
    axios.get("api/type/" + payload.reference).then(response => {
      state.settings.object = response.data;
      // var array = response.data.fields;
      // var output_fields = [];
      // if (array != undefined) {
      //   for (var sindex = 0; sindex < array.length; sindex++) {
      //     var section = array[sindex];
      //     if (section.length >= 0) {
      //       for (var rindex = 0; rindex < section.length; rindex++) {
      //         var row = section[rindex];
      //         for (var findex = 0; findex < row.length; findex++) {
      //           var field = row[findex];
      //           output_fields.push(field);
      //         }
      //       }
      //     }
      //   }
      // }
      // state.settings.objectFields = response.data.fields;
    });
  },

  newFormTemplate: ({ state }, payload) => {
    axios
      .post("api/forms/templates", {
        name: state.form.name,
        description: state.form.description
      })
      .then(response => {
        state.form.templates = response.data;
        state.form.name = "";
        state.form.description = "";
      });
  },

  storeForm: ({ state }) => {
    axios
      .post(
        "api/forms/template/" + state.form.template.reference,
        state.form.template
      )
      .then(response => {
        state.form.template = response.data;
      });
  },

  applyForm: ({ state }) => {
    axios.put("api/form/" + state.form.content.reference).then(response => {
      this.router.push("/formulieren");
    });
  },

  // routing actions
  toObject: ({ state, dispatch }, payload) => {
    // get the full object details
    dispatch("getObject", {
      reference: payload.reference
    });
    dispatch("getContracts", {
      parent: payload.reference
    });
    if (state.app.form.hasChange == true) {
      state.app.form.hasChange = false;
    }
    router.push("/object");
  },

  toContract: ({ state, dispatch }, payload) => {
    state.app.merkato.load = false;
    dispatch("getContract", {
      reference: payload.reference
    });
    router.push("/contract");
  },


  toForm: ({ dispatch }, payload) => {
    dispatch("getForm", {
      reference: payload.reference
    });
    router.push("/formulier");
  },

  toObjects: ({ state }) => {
    if (state.object.category.managed == true) {
      router.push("/objecten");
    } else if (state.object.category.crm == true) {
      router.push("/crm");
    } else {
      router.push("/objecten");
    }
  },

  // dialog actions
  deleteDialogItem: ({ state, dispatch, commit }) => {
    if (state.archive.type == "contract") {
      // delete the selected contract and update the contract list
      dispatch("deleteContract", {
        reference: state.archive.reference
      });
    } else if (state.archive.type == "object") {
      dispatch("deleteObject", {
        reference: state.archive.reference
      });
    } else if (state.archive.type == "form") {
      dispatch("deleteForm", {
        reference: state.archive.reference
      });
    }
    commit("closeArchiveDialog");
  },
  logout: ({ state, commit }) => {
    clearInterval(state.runstatistics);
    commit("resetUser");
    router.push("/login");
  }
};
